/**
 * How long BlockingStatusOverlay takes to fade in or out (0.25 s, the desktop
 * apps' `.easeInOut(duration: 0.25)`). It must equal the duration of the
 * `fade-in` / `fade-out` animations in tailwind.config.js:
 * src/__tests__/blockingOverlayFadeMirrorsTailwind.test.ts pins the two together.
 */
export const BLOCKING_OVERLAY_FADE_MS = 250;
